var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.536014 29.499C0.150049 30.1656 0.631107 31 1.40144 31H34.5992C35.3695 31 35.8506 30.1656 35.4646 29.499L18.8658 0.828171C18.4806 0.162886 17.5201 0.162886 17.1349 0.828171L0.536014 29.499ZM19.667 25C19.667 25.5523 19.2193 26 18.667 26H17.3337C16.7814 26 16.3337 25.5523 16.3337 25V23.6667C16.3337 23.1144 16.7814 22.6667 17.3337 22.6667H18.667C19.2193 22.6667 19.667 23.1144 19.667 23.6667V25ZM19.667 18.3333C19.667 18.8856 19.2193 19.3333 18.667 19.3333H17.3337C16.7814 19.3333 16.3337 18.8856 16.3337 18.3333V13.6667C16.3337 13.1144 16.7814 12.6667 17.3337 12.6667H18.667C19.2193 12.6667 19.667 13.1144 19.667 13.6667V18.3333Z",
    fill: "#C8102E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.9ed55cd2ba039f3fff68e684184c89b6.svg";
export { ForwardRef as ReactComponent };